export class ResetAuditTrailDrawerState {
  static readonly type = '[AuditTrailDrawer] ResetAuditTrailDrawerState';
}

export class SetAuditTrailDrawerOpenState {
  static readonly type = '[AuditTrailDrawer] SetAuditTrailDrawerState';
  constructor(public openStatus: boolean) {}
}

export class SetAuditTrailDrawerCurrentShiftIdState {
  static readonly type =
    '[AuditTrailDrawer] SetAuditTrailDrawerCurrentShiftIdState';
  constructor(public currentShiftId: string) {}
}
